<template>
  <div>
    <v-app-bar
      class="elevation-0"
      app
      dark
    >
      <core-toolbar />
    </v-app-bar>

    <v-container />

    <v-footer
      class="pl-6 pa-0 grey--text caption"
      height="32px"
      absolute
    >
      <v-row class="align-center justify-center wrap fill-height text-center">
        <v-col cols="auto">
          <span>v.{{ appVersion }}</span>
        </v-col>

        <v-col>
          <span>Komacut&reg; www.komacut.com</span>
          <span>
            &copy;
            {{ new Date().getFullYear() }}
            <a href="https://www.komacut.com/" target="_blank">
              All Rights Reserved.
            </a>
            Komacut&reg; is a registered trademark of KomaSpect.
            <a href="https://www.komacut.com/" target="_blank">Privacy</a>
            and
            <a href="https://www.komacut.com/" target="_blank">Terms.</a>
          </span>
        </v-col>
      </v-row>
    </v-footer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import AuthMixin from '../mixins/auth';

export default {
  mixins: [AuthMixin],

  props: {
    footer: { type: String, default: '&copy; 2019' },
  },

  asyncComputed: {
    isAdmin() {
      return this.isAdminAction();
    },
  },

  computed: {
    ...mapGetters('app', ['appVersion']),
  },
};
</script>

<style>
.avatar {
  width: 32px !important;
  height: 32px !important;
}
</style>
